module.exports = __webpack_public_path__ + "static/media/waiting-wrist-watch.7ba65380.svg";